/**
 * AerialImageCarousel component for Commercial PDP.
 * Displays aerial view images in a navigable carousel with circular navigation.
 * When only one image is available, navigation controls are hidden.
 */
import { useState } from 'react';

/* eslint-disable react/prop-types */
const AerialImageCarousel = ({ images, onAllImagesFailed }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [failedIndices, setFailedIndices] = useState(new Set());

  const goNext = () => setCurrentIndex((prev) => (prev + 1) % images.length);
  const goPrev = () => setCurrentIndex((prev) => (prev - 1 + images.length) % images.length);

  const handleImageError = () => {
    const newFailedIndices = new Set(failedIndices);
    newFailedIndices.add(currentIndex);
    setFailedIndices(newFailedIndices);

    if (newFailedIndices.size === images.length) {
      onAllImagesFailed();
      return;
    }

    // Find the next non-failed index (circular search)
    let nextIndex = (currentIndex + 1) % images.length;
    while (newFailedIndices.has(nextIndex)) {
      nextIndex = (nextIndex + 1) % images.length;
    }
    setCurrentIndex(nextIndex);
  };

  if (!images || images.length === 0) {
    return null;
  }

  return (
    <div className="aerial-carousel">
      <img
        className="aerial-carousel__image"
        src={images[currentIndex].url}
        alt={images[currentIndex].alt}
        onError={handleImageError}
      />
      {images.length > 1 && (
        <>
          <button
            className="aerial-carousel__nav-btn aerial-carousel__nav-btn--prev"
            onClick={goPrev}
            aria-label="Previous aerial image"
          >
            ‹
          </button>
          <button
            className="aerial-carousel__nav-btn aerial-carousel__nav-btn--next"
            onClick={goNext}
            aria-label="Next aerial image"
          >
            ›
          </button>
          <div className="aerial-carousel__indicators">
            {images.map((_, index) => (
              <span
                key={index}
                className={`aerial-carousel__dot${index === currentIndex ? ' aerial-carousel__dot--active' : ''}`}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default AerialImageCarousel;
